<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center ">
            <img src="assets/images/logos/ic.svg" style="width: 70%;">
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12 form-horizontal">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="bg-registro-light" style="padding-top: 10px;padding-bottom: 10px; overflow: hidden;">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">

                            <p class="lead text-center mobile-content-hide">Crear nueva contraseña.</p>

                            <p class="lead text-left mobile-content-show">Crear nueva contraseña.</p>

                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>

                <div [formGroup]="resetPassword">
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Nueva contraseña <small class="text-muted f11"><em>(Debe contener mínimo 6
                                        caracteres)</em></small></label>
                            <input #xPass name="password" formControlName="password" type="password" placeholder="Vuelve a ingresar tu contraseña" class="form-control input-md placeholder-input input-form-usuario-registro" minlength="6" required [ngClass]="{'is-valid': resetPassword.get('password').valid, 'is-invalid':resetPassword.get('password').invalid && (resetPassword.get('password').dirty) }">
                            <span (click)="xPass.type = xPass.type == 'password' ? 'text' : 'password'" class="{{xPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Confirmar contraseña</label>
                            <input #xConfPass name="confirmpassword" formControlName="confirmpassword" type="password" placeholder="Vuelve a ingresar tu contraseña" class="form-control input-md placeholder-input input-form-usuario-registro" minlength="6" required [ngClass]="{'is-valid': resetPassword.get('confirmpassword').valid, 'is-invalid':resetPassword.get('confirmpassword').invalid && (resetPassword.get('confirmpassword').dirty) }">
                            <span (click)="xConfPass.type = xConfPass.type == 'password' ? 'text' : 'password'" class="{{xConfPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12 text-center">
                        <div *ngIf="resetPassword.get('confirmpassword').errors && resetPassword.get('confirmpassword').errors['mustMatch']" class="text-error"><i class="fa fa-exclamation-circle"></i> Las contraseñas deben coincidir.
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-12 mobile-content-show">
                    <div class="col-lg-2"></div>
                    <div class="form-group col-lg-8">
                        <button [disabled]="!resetPassword.valid" (click)="onResetPassword()" class="col-xs-6" class="btn btn-lg btn-orange btn-block m0top">Crear contraseña</button>
                    </div>
                    <div class="col-lg-2"></div>
                </div> -->

            </div>

            <div class="col-lg-12">
                <br />
            </div>

            <div class="col-lg-12">
                <div class="col-lg-6">
                    <a (click)="clickBackConfig()" class="btn btn-lg btn-atras btn-block m0top">Volver al login</a>
                </div>
                <div class="col-lg-6">
                    <button [disabled]="!resetPassword.valid" (click)="onResetPassword()" type="submit" class="btn btn-lg btn-orange btn-block m0top">Crear contraseña</button>
                </div>
            </div>

        </div>
        <div class="col-lg-3"></div>
    </div>
</div>